<div class="product-details-card">
  <div class="product-details-card__auth" *ngIf="!isLogged">
    <atm-auth-banner />
  </div>
  <div class="product-details-card__context">
    <div class="product-details-card__headings">
      <!-- Headings -->
      <div
        class="product-details-card__headings__container"
        *ngIf="product?.type !== 'Capacitaciones'">
        <div>
          <!-- Cas -->
          <div
            class="product-details-card__headings__section"
            *ngIf="product?.cas">
            <p class="m-0 text-subtle">CAS</p>
            <p class="m-0 text-paragraph text-bold">
              {{ product?.cas }}
            </p>
          </div>

          <!-- Cat -->
          <div
            class="product-details-card__headings__section"
            *ngIf="product?.catalog">
            <p class="m-0 text-subtle">CAT</p>
            <p class="m-0 text-paragraph text-bold">
              {{ product?.catalog }}
            </p>
          </div>
        </div>

        <img
          *ngIf="brandImgPath"
          [src]="brandImgPath"
          alt="product brand"
          width="62px"
          height="62px" />
      </div>

      <!-- Image -->
      <div class="product-details-card__headings__image">
        <img [src]="presentationImgPath" alt="brand image" />
      </div>
    </div>

    <div class="product-details-card__info">
      <div class="product-details-card__info__controlled" *ngIf="isControlled">
        <ng-icon
          size="16"
          strokeWidth="2"
          name="heroLockClosed"
          color="#C2410C"></ng-icon>
        <span class="text-x-small">Controlado</span>
      </div>

      <div class="product-details-card__info__heading" *ngIf="!isControlled">
        <h1
          class="product-details-card__info__title text-bold text-subtle text-primary-900">
          {{ product?.type }}
        </h1>
        <span class="media-type" *ngIf="product?.mediaOutlet">
          {{ product?.mediaOutlet }}
        </span>
        <span class="media-type" *ngIf="product?.publicationFormat">
          {{ product?.publicationFormat }}
        </span>
      </div>

      <p
        class="product-details-card__info__description text-paragraph-2 text-gray-green-900">
        {{ product?.description }}
      </p>

      <p
        class="text-paragraph text-neutral-500 training-product-description"
        *ngIf="product?.trainingProductDescription">
        {{ product?.trainingProductDescription }}
      </p>

      <span
        class="text-paragraph text-neutral-500 product-author"
        *ngIf="product?.author">
        por {{ product?.author }}
      </span>

      <p class="text-subtle text-blue-900" *ngIf="product?.isbn">
        ISBN <span class="text-bold">{{ product?.isbn }}</span>
      </p>

      <div *ngIf="!isLogged">
        <div
          class="product-details-card__info__price__blurred"
          *ngIf="!isLogged">
          <p class="blurred-text no-select regular-price text-primary-500">
            {{ 234 | usdCurrency }}
          </p>
          <span
            class="login-text text-paragraph text-primary-500"
            (click)="openLoginModal($event)">
            Inicia sesión para ver precios
          </span>
        </div>
        <p
          class="text-paragraph text-blue-900"
          *ngIf="
            product?.offert?.deliveryTimeDays &&
            product?.typeKey !== 'training' &&
            product?.typeKey !== 'publications'
          ">
          Envío en
          <span class="text-bold text-center"
            >{{ product?.offert?.deliveryTimeDays }} Días</span
          >
        </p>
      </div>

      <div *ngIf="isLogged">
        <div class="product-details-card__info__market">
          <div class="product-details-card__info__market__pricing">
            <p
              class="text-paragraph text-gray-green-500 line-through"
              *ngIf="(priceWeb$ | async) !== null">
              {{ priceWeb$ | async | usdCurrency }}
            </p>
            <p
              class="regular-price text-primary-500"
              *ngIf="(priceVD$ | async) !== null">
              {{ priceVD$ | async | usdCurrency }}
              <span class="text-paragraph text-gray-green-900">p/u</span>
            </p>
          </div>
          <div
            class="product-details-card__info__market__cart"
            *ngIf="product?.typeKey !== 'training'">
            <p class="text-paragraph text_unit_measure">
              U. Medida
              <span class="text-bold"> {{ product?.unitMeasure }} </span>
            </p>
            <atm-quantity-selector
              [quantity]="productUnits"
              [disabled]="isAddingToCar$ | async"
              (quantityChange)="updateProductUnits($event)"
              [cartMode]="false" />
          </div>
        </div>

        <div
          class="product-details-card__info__footer-training"
          *ngIf="product?.typeKey === 'training'; else footer">
          <div class="message">
            <span>Comunícate con Asesor Comercial para cotizar.</span>
          </div>
          <div class="contact">
            <a href="mailto:ventas@proquifa.com.mx"
              >ventas&#64;proquifa.com.mx</a
            >
            <span> | </span>
            <a href="tel:+525513151498">(55) 1315 1498</a>
          </div>
        </div>

        <ng-template #footer>
          <div class="product-details-card__info__footer">
            <div class="text-paragraph instant" *ngIf="hasExistingStock">
              <ng-icon
                class="icon"
                size="12"
                strokeWidth="2"
                name="heroCheckCircle"></ng-icon>
              <span class="text-bold text-center">Entrega inmediata </span>
            </div>
            <div>
              <p
                class="text-paragraph text-blue-900"
                *ngIf="isProductEligible">
                Envío en
                <span class="text-bold text-center"
                  >{{ product?.offert?.deliveryTimeDays }} Días</span
                >
              </p>
            </div>
            <button
              class="btn --primary shooping-car-button"
              (click)="addToQuotation()"
              [disabled]="
                (isAddingToCar$ | async) || productUnitIsNotAnInteger
              ">
              <ng-icon name="heroShoppingCart" size="24"></ng-icon>
              <span class="text-large">Agregar a Cotización</span>
            </button>
            <ng-content></ng-content>
          </div>
        </ng-template>
      </div>

      <a
        *ngIf="showSeeAllDetails"
        [routerLink]="['/products', product?.idProduct]"
        class="see-all-details-link no-decoration">
        Ver todos los detalles
        <ng-icon size="16" name="heroChevronRight"></ng-icon>
      </a>
    </div>
  </div>
</div>
